import {useContext} from "react";
import stickyHeaderContext from "./context";

export function useStickyOffset(): number {
  return useContext(stickyHeaderContext).offset;
}
